import type { jsPDF } from 'jspdf';

const site = 'https://www.francisney.com.br';
const whatsapp = 'https://wa.me/5565999031061';

/** Applies the signed, clickable footer required in every platform report. */
export function addPdfFooter(pdf: jsPDF, note?: string) {
  const pages = pdf.getNumberOfPages();
  for (let page = 1; page <= pages; page += 1) {
    pdf.setPage(page);
    pdf.setTextColor(23, 107, 92); pdf.setFontSize(8.5);
    pdf.text('Continue servindo com propósito e constância.', 16, 265);
    pdf.setDrawColor(184, 209, 197); pdf.line(16, 270, 194, 270);
    if (note) {
      pdf.setTextColor(82, 99, 109); pdf.setFontSize(7.5);
      pdf.text(note, 16, 276, { maxWidth: 178 });
    }
    pdf.setTextColor(23, 107, 92); pdf.setFontSize(8.5);
    pdf.textWithLink('Francisney Liberato', 16, 284, { url: site });
    pdf.setTextColor(82, 99, 109); pdf.text('|', 53, 284);
    pdf.setTextColor(23, 107, 92); pdf.textWithLink('www.francisney.com.br', 58, 284, { url: site });
    pdf.setTextColor(82, 99, 109); pdf.text('|', 111, 284);
    pdf.setTextColor(23, 107, 92); pdf.textWithLink('WhatsApp +55 (65) 99903-1061', 116, 284, { url: whatsapp });
  }
}
